import type { UseMutationResult } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';

import type { IApiDeleteAdResponseBody } from '../AdsApi.types';
import { useApi } from '~/lib/api/useApi';
import { adQueryKeyFactory } from './useAdQuery';
import { adsQueryKeyFactory } from './useAdsQuery';

export type IUseDeleteAdMutationValues = {
  appId: string;
  adId: string;
};

export const useDeleteAdMutation = (): UseMutationResult<
  IApiDeleteAdResponseBody,
  unknown,
  IUseDeleteAdMutationValues
> => {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (values: IUseDeleteAdMutationValues) =>
      api.ads.delete(values.appId, values.adId),
    onSuccess: async (_, values) => {
      // TODO once the API is updated to return the deleted resources
      // data.deletedResources.adIds
      [values.adId]
        .map((adId) => [
          {
            queryKey: adQueryKeyFactory({
              appId: values.appId,
              adId,
            }),
          },
        ])
        .flat()
        .forEach((filters) => queryClient.removeQueries(filters));

      await queryClient.invalidateQueries({
        queryKey: adsQueryKeyFactory({ appId: values.appId }),
      });
    },
  });
};
